import React from 'react';
import styled from 'styled-components';
import { buttonCss } from './button';

export const ButtonNarrowLink = ({ children, ...props }) => (
  <ButtonView {...props}>
    <React.Fragment>{children}</React.Fragment>
  </ButtonView>
);

const ButtonView = styled.a`
  ${buttonCss};
  height: 40px;
  font-size: 18px;
`;
